<template>
    <div>
        <template v-if="value.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value">
            <v-simple-checkbox :value="value.data" color="primary" />
        </template>
        <template v-else>
            <template v-if="false"></template>
            <template v-else-if="mode == 'done'">
                <v-simple-checkbox :value="value.data" color="primary" />
            </template>
            <template v-else-if="mode == 'sign'">
                <v-simple-checkbox v-model="form.data" color="primary" @click="emit" />
            </template>
            <template v-else>
                <span style="opacity: 0.5; word-break: auto-phrase;">
                    {{ value.term }}
                </span>
            </template>
        </template>
    </div>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, initEmploymentField } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initEmploymentField },

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
    },
    data: () => ({
        form: initEmploymentField(),
        EMPLOYMENT_FIELD_SIDES,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input--selection-controls__input {
    margin: 0 !important;
}
</style>
